var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 18,
    height: 18,
    transform: "translate(346.023 313.403)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon_white_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_white_1",
    "data-name": "Icon white \\u2013 1",
    clipPath: "url(#clip-Icon_white_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3828",
    "data-name": "Group 3828",
    transform: "translate(-346.023 -313.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3827",
    "data-name": "Group 3827",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_6260",
    "data-name": "Path 6260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3817",
    "data-name": "Group 3817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6271",
    "data-name": "Path 6271",
    d: "M359.768,325.46a.4.4,0,0,1-.374-.258,2.114,2.114,0,0,0-.631-.882,1.672,1.672,0,0,0-.69-.365l-2.194-.637a.868.868,0,0,1-.243-.113.885.885,0,0,1-.382-.624l-.125-1.084.172-.139a3.342,3.342,0,0,0,1.141-1.8l.069-.276.284-.026c.157-.014.324-.265.324-.616a.594.594,0,0,0-.35-.63.4.4,0,1,1,.3-.74,1.546,1.546,0,0,1,.084,2.711,4.156,4.156,0,0,1-1.181,1.849l.075.652,2.234.7a2.448,2.448,0,0,1,1,.527,2.918,2.918,0,0,1,.862,1.208.4.4,0,0,1-.233.516A.39.39,0,0,1,359.768,325.46Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6261",
    "data-name": "Path 6261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6272",
    "data-name": "Path 6272",
    d: "M357.966,328.557H347.431a.52.52,0,0,1-.513-.62l.51-2.557a2.914,2.914,0,0,1,1-1.673,2.445,2.445,0,0,1,1.011-.526l2.16-.627.119-.723a4.18,4.18,0,0,1-1.174-1.842,1.417,1.417,0,0,1-.762-1.34,1.362,1.362,0,0,1,.821-1.366.4.4,0,1,1,.323.732.582.582,0,0,0-.346.593c0,.387.172.643.324.657l.283.026.07.276a3.356,3.356,0,0,0,1.142,1.8l.172.139-.125,1.082a.876.876,0,0,1-.624.739l-2.175.631a1.691,1.691,0,0,0-.7.363,2.128,2.128,0,0,0-.734,1.221l-.443,2.22h10.2a.4.4,0,0,1,0,.8Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6262",
    "data-name": "Path 6262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3819",
    "data-name": "Group 3819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6273",
    "data-name": "Path 6273",
    d: "M350.762,318.049a.4.4,0,0,1-.4-.382,4.618,4.618,0,0,1,1.054-3.089,3.586,3.586,0,0,1,4.861,0,4.6,4.6,0,0,1,1.039,3.085.369.369,0,0,1-.419.379.4.4,0,0,1-.379-.418,3.834,3.834,0,0,0-.824-2.5,2.795,2.795,0,0,0-3.7,0,3.836,3.836,0,0,0-.833,2.5.4.4,0,0,1-.382.417Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6263",
    "data-name": "Path 6263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6274",
    "data-name": "Path 6274",
    d: "M355.287,316.82a3.518,3.518,0,0,1-.5-.035,6.343,6.343,0,0,1-1.987-.738,1.424,1.424,0,0,0-1.056-.122.745.745,0,0,0-.4.357.4.4,0,0,1-.709-.371,1.551,1.551,0,0,1,.868-.749,2.244,2.244,0,0,1,1.684.188,5.549,5.549,0,0,0,1.727.647,2.733,2.733,0,0,0,1.6-.266.4.4,0,1,1,.357.716A3.544,3.544,0,0,1,355.287,316.82Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_676",
    "data-name": "Line 676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3821",
    "data-name": "Group 3821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6275",
    "data-name": "Path 6275",
    d: "M353.848,325.354a.4.4,0,0,1-.288-.122l-2.008-2.082a.4.4,0,0,1,.576-.556l2.008,2.082a.4.4,0,0,1-.288.678Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_677",
    "data-name": "Line 677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6276",
    "data-name": "Path 6276",
    d: "M353.849,325.354a.4.4,0,0,1-.288-.678l2.007-2.082a.4.4,0,0,1,.577.556l-2.008,2.082A.4.4,0,0,1,353.849,325.354Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_545",
    "data-name": "Ellipse 545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3823",
    "data-name": "Group 3823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6277",
    "data-name": "Path 6277",
    d: "M360.393,330.892a2.827,2.827,0,1,1,2.407-1.341A2.818,2.818,0,0,1,360.393,330.892Zm0-4.855a2.028,2.028,0,0,0-1.068,3.752,2.072,2.072,0,0,0,2.791-.659,2.028,2.028,0,0,0-1.723-3.093Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_678",
    "data-name": "Line 678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3824",
    "data-name": "Group 3824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6278",
    "data-name": "Path 6278",
    d: "M360.393,329.686a.4.4,0,0,1-.4-.4v-2.443a.4.4,0,0,1,.8,0v2.443A.4.4,0,0,1,360.393,329.686Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_679",
    "data-name": "Line 679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3825",
    "data-name": "Group 3825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6279",
    "data-name": "Path 6279",
    d: "M361.613,328.465h-2.442a.4.4,0,1,1,0-.8h2.442a.4.4,0,1,1,0,.8Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_6264",
    "data-name": "Path 6264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3826",
    "data-name": "Group 3826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6280",
    "data-name": "Path 6280",
    d: "M356.077,323.518l-1.858,1.968a.522.522,0,0,1-.736.005l0-.005-1.858-1.968-.758.231,2.977,3.185.009-.008.009.008,2.977-3.185Z",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAccount);
export default __webpack_public_path__ + "static/media/addAccount.c6d5843da38813673ba3807eb288a5a1.svg";
export { ForwardRef as ReactComponent };